import { clone } from '@jack-henry/frontend-utils/functions';
import { ProductFeatureModelDto } from '@treasury/api/bo';
import { CompanyProductFeature } from './company-product-feature.entity';

const defaultDto: ProductFeatureModelDto = {
    id: 0,
    type: 'AgileticsSso',
    productUniqueId: '',
    isConfigurable: true,
};

export class AgileticsWebEscrowProductFeature extends CompanyProductFeature<ProductFeatureModelDto> {
    constructor(dto: ProductFeatureModelDto = clone(defaultDto)) {
        super(dto);
    }
}
